import React from 'react';
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faLink } from '@fortawesome/free-solid-svg-icons';
import key from './key.png';
import { CopyBox } from '../../components/CopyBox';
import DatasourceAccess from '../DatasourceAccess';
import styles from './DatasourceAccessRequest.module.scss';
import { DatasourceAccessPageContainer } from '../../components/DatasourceAccessPageContainer';

// @ts-expect-error: Will be not needed once we use our custom icons.
library.add(faLink);
export const DatasourceAccessRequest: React.FC = () => {
  const { datasourceId } = useParams();
  return (
    <DatasourceAccessPageContainer>
      <DatasourceAccess
        image={key}
        headerText="Request access"
        descriptionText="Please ask the customer to visit the link below and grant you access"
      />
      <div className={styles.copyButtonContainer}>
        <CopyBox
          value={`${window.origin}/grant/${datasourceId}`}
          text="Copy link"
          className={styles.copyButtonCustomStyles}
          icon={<FontAwesomeIcon icon="link" />}
        />
      </div>
    </DatasourceAccessPageContainer>
  );
};

export default DatasourceAccessRequest;
